"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./inject");
var Spinner = function (_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.spinnerColor, spinnerColor = _c === void 0 ? '#333333' : _c, _d = _a.spinnerWidth, spinnerWidth = _d === void 0 ? 5 : _d, _e = _a.size, size = _e === void 0 ? 40 : _e, rest = __rest(_a, ["visible", "spinnerColor", "spinnerWidth", "size"]);
    if (!visible) {
        return null;
    }
    return (React.createElement("div", __assign({}, rest, { className: "react-spinner-material", style: {
            width: size,
            height: size,
            borderColor: spinnerColor,
            borderWidth: spinnerWidth
        } })));
};
exports.default = Spinner;
